export default "__VITE_ASSET__DTXJwBTc__"